import { API } from "aws-amplify";
import { createUserCart } from "../../../graphql/mutations";
import { createUserProductsCart, deleteUserProductsCart, GetByUserCart, updateUserProductsCart, userCartsByCartId, userProductsCartsByCarttableID } from "../../../Layout/MutaionsAndQueries";
import { showToast } from "../../../components/ToastUtils";

//Customer Cart Creation API
export const CreateNewCart = async ({ AddNewCartDetails }) => {
    try {
        const NewCartResponse = await API.graphql({
            query: createUserCart,
            variables: { input: AddNewCartDetails },
        });
        return { Status: "Open", Data: NewCartResponse.data.createUserCart }

    } catch (error) {
        console.error("CreateNewCart Error", error);
        return { Status: "Error" }
    }
}

//Add to Cart API
export const AddNewProductToCart = async ({ CartProductDetails, carttableID, userDetails }) => {
    try {
        const addcartResult = await API.graphql({
            query: createUserProductsCart,
            variables: {
                input: { ...CartProductDetails, carttableID },
                customerUUID: userDetails["custom:customer_UUID"]
            },
        });

        return ({ Status: "Success", Data: addcartResult.data.createUserProductsCart })

    } catch (error) {
        console.error("AddNewProductToCart Error", error);
        return ({ Status: "Error" });
    }

}

//Same Product in the cart checking API
export const AlreadyProductInCart = async ({ ProductID, ProductPriceUOMCode, carttableID }) => {
    try {
        const SameProductCheckingResponse = await API.graphql({
            query: userProductsCartsByCarttableID,
            variables: {
                carttableID: carttableID,
                filter: {
                    and: [
                        { userProductsCartProductdetailsId: { eq: ProductID } },
                        { ProductPriceUOMCode: { eq: ProductPriceUOMCode } }
                    ]
                },
            },
        });
        if (SameProductCheckingResponse.data.userProductsCartsByCarttableID.items.length > 0) {
            return ({ Status: "SameProductInCart", Data: SameProductCheckingResponse.data.userProductsCartsByCarttableID.items[0] })
        } else {
            return ({ Status: "NotSameProductInCart" })
        }
    } catch (error) {
        console.error("AlreadyProductInCart error", error);
        return ({ Status: "Error" });
    }
}

//Update Cart API
export const UpdateCartProductQty = async (InputVariable) => {
    try {
        const CartProductUpdate = await API.graphql({
            query: updateUserProductsCart,
            variables: {
                input: InputVariable
            }
        })
        return ({ Status: "Success", Data: CartProductUpdate.data.updateUserProductsCart })
    } catch (error) {
        console.error("UpdateCartProductQty Error", error);
        return ({ Status: "Error" });
    }

}

//Cart Status Checking API
export const CartStatusChecking = async ({ CartAutoid }) => {
    try {
        const UserCartResponse = await API.graphql(
            {
                query: GetByUserCart,
                variables: {
                    id: CartAutoid
                }
            }
        )

        if (UserCartResponse.data.getUserCart) {
            return { Status: "Success", Data: UserCartResponse.data.getUserCart }
        }
    } catch (error) {
        console.error("CartStatusChecking error:", error);
        return { Status: "Error" }
    }
}

// Cart Product Remove From Cart 
export const RemoveProductFromCart = async ({ CartProductID, CartRelatedDispatch, Actions }) => {
    try {
        const responseRemoveCartProduct = await API.graphql({
            query: deleteUserProductsCart,
            variables: {
                input: {
                    id: CartProductID,
                },
            },
        })
        CartRelatedDispatch({
            type: Actions.DeleteProductFromCart,
            payload: {
                id: responseRemoveCartProduct.data.deleteUserProductsCart.id,
                userProductsCartProductdetailsId: responseRemoveCartProduct.data.deleteUserProductsCart.userProductsCartProductdetailsId
            }
        })
        return true;
    } catch (error) {
        console.error("RemoveProductFromCart Error", error);
        showToast("Something Wents Wrong. Please Contact Admin", "error", 3000);
    }
}